import { CarryEntityDetail } from '@/components/funds-carry/structure/CarryEntityDetail';
import { PORTAL_CARRY_STRUCTURE_PATH } from '../carryPaths';
import { memberEntity } from '../components/structure/memberStructure';
import { PortalStructureData } from '../components/structure/PortalStructureData';

export function PortalCarryStakPage() {
  return (
    <PortalStructureData>
      {(structure, positions) => (
        <CarryEntityDetail
          entity={memberEntity(
            structure.stak,
            structure,
            structure.member_type === 'DR_HOLDER' ? positions : []
          )}
          structurePath={PORTAL_CARRY_STRUCTURE_PATH}
          kind="Trust office"
          kindClassName="text-amber-700 dark:text-amber-400"
          description="The STAK holds the economic interest for DR holders. Voting rights remain with the board."
          holdersLabel="Your depositary receipts"
          holdersTitle="Your depositary receipts"
          holdersNote="You only see your own position"
        />
      )}
    </PortalStructureData>
  );
}
